<template>
  <div>
    <DetailSheetHeader :title="$t('waypoint_dialog.edit_waypoint_details.edit_waypoint')" show-back @back="backClicked" />

    <div class="form-group p-3">

      <p><label for="" class=""><small><strong>{{ $t('waypoint_dialog.edit_waypoint_details.waypoint_type') }}</strong></small></label></p>

      <div class="input-group mb-3 text-muted">
        <select class="custom-select form-select rounded-pill w-100 p-2" id="waypointType" v-model="selectedWaypoint.type">
          <option v-for="waypointType in allWaypointTypes" :key="waypointType.poi" :value="waypointType.poi">
            {{ waypointType.prettyName() }}
          </option>
        </select>
      </div>

      <hr class="my-3">

      <p><label for="plannedTrailName" class=""><small><strong>{{ $t('shared.name') }}</strong></small></label></p>
      <input type="text" v-model="title" class="form-control rounded-pill w-100 p-2" id="plannedTrailName"
              :placeholder="$t('waypoint_dialog.edit_waypoint_details.enter_name')">

      <hr class="my-3">

      <p><label for="plannedTrailDesc"><small><strong>{{ $t('shared.description') }}</strong></small></label></p>
      <textarea class="form-control mb-3 rounded-lg p-2" id="plannedTrailDesc" v-model="description" :placeholder="$t('waypoint_dialog.edit_waypoint_details.some_details_about_the_waypoint')"></textarea>

      <hr class="my-3">

      <p><label for="plannedTrailImg" class="form-label"><small><strong>{{ $t('waypoint_dialog.edit_waypoint_details.add_images') }}</strong></small></label></p>
      <form class="custom-file">
        <button class="btn btn-secondary w-100" @click="triggerFileInput($event)">{{ $t('shared.choose_files') }}</button>
        <input
          multiple="multiple" ref="fileInput" accept=".jpg, .jpeg, .png" id="plannedTrailImg"
          type="file" class="custom-file-upload w-100" style="display: none;" @change="handleFileInputChange"
        />
        <div class="thumbnails mt-2 mb-2">
          <div v-for="(previewObj, index) in previewUrls" :key="index" class="thumbnail square">
            <img :src="previewObj.file.url" :alt="`image-${index}`" class="thumbnail-image" />
            <button @click="removeImage($event, previewObj)" class="delete-button btn-secondary">x</button>
          </div>
        </div>
      </form>

      <hr class="my-3">

      <p><label for="plannedTrailImg" class="form-label"><small><strong>{{ $t('waypoint_dialog.edit_waypoint_details.group') }}</strong></small></label></p>
      <form class="custom-file">
        <button class="btn btn-secondary w-100" @click="chooseGroupClicked($event)">{{ $t('waypoint_dialog.edit_waypoint_details.choose_group') }}</button>
      </form>
      <hr class="my-3">


      <p><label for="" class=""><small><strong>{{ $t('shared.who_can_view') }}</strong></small></label></p>
      <div class="input-group mb-3 text-muted">
        <select class="custom-select form-select rounded-pill w-100 p-2" id="plannedTrailPrivacy" @change="privacyChanged">
          <template v-if="selectedWaypoint.public">
            <option value="1" selected>{{ $t('shared.everyone_can_view') }}</option>
            <option value="2">{{ $t('shared.only_i_can_view') }}</option>
          </template>
          <template v-else>
            <option value="1">{{ $t('shared.everyone_can_view') }}</option>
            <option value="2" selected>{{ $t('shared.only_i_can_view') }}</option>
          </template>
        </select>
      </div>

      <hr class="my-3">

      <div class="d-flex">
        <button class="btn btn-secondary flex-fill mr-2 mt-3" data-bs-dismiss="modal" @click="cancel">{{ $t('shared.cancel') }}
        </button>
        <button class="btn btn-primary flex-fill mt-3" @click="save">{{ $t('waypoint_dialog.edit_waypoint_details.save') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from 'bootstrap';
import { defineComponent } from 'vue';
import { mapState } from 'vuex';
// eslint-disable-next-line import/extensions,import/no-unresolved
import { POIUtility } from '../../../utils/models/POI';
import {WaypointOptionsDialogPages} from "../../../utils/models/WaypointOptionsDialogPages";
import DetailSheetHeader from '../../../utils/shared_components/detail_sheet/DetailSheetHeader.vue';

export default defineComponent({
  components: { DetailSheetHeader },
  data() {
    return {
      allWaypointTypes: [],
    };
  },
  mounted() {
    this.allWaypointTypes = POIUtility.allPOIUtils();
  },
  computed: Object.assign(mapState({
    selectedWaypoint: (state) => state.waypoints.selectedWaypoint,
  }), {
    title: {
      get() {
        return this.selectedWaypoint.title;
      },
      set(newValue) {
        this.$store.commit('waypoints/setSelectedWaypointTitle', newValue);
      },
    },
    description: {
      get() {
        return this.selectedWaypoint.description;
      },
      set(newValue) {
        this.$store.commit('waypoints/setSelectedWaypointDescription', newValue); // Example of using Vuex to set a value.
      },
    },
    previewUrls() {
      return this.selectedWaypoint.waypointPhotos;
    },
  }),
  methods: {
    backClicked() {
      this.$store.commit('waypoints/popPage');
    },
    privacyChanged() {
      this.selectedWaypoint.public = !this.selectedWaypoint.public;
    },
    save() {
      this.$store.dispatch('waypoints/saveSelectedWaypoint');
    },
    cancel() {
      // `Modal` used to be referenced here without being imported, so this threw
      // and only the button's data-bs-dismiss actually closed the dialog.
      const element = document.getElementById('waypoint-options-dialog');
      if (element) Modal.getInstance(element)?.hide();
    },
    triggerFileInput(event) {
      event.preventDefault();
      this.$refs.fileInput.click(); // Trigger the click event on the file input
    },
    removeImage(event, image) {
      event.preventDefault();
      this.$store.dispatch('waypoints/provisionallyRemoveWaypointImage', image);
    },
    async handleFileInputChange(event) {
      const { files } = event.target;
      if (files.length > 0) {
        this.$store.dispatch('waypoints/uploadWaypointImages', files);
      }
    },
    chooseGroupClicked(event) {
      event.preventDefault();
      this.$store.commit('waypoints/setTopPage', WaypointOptionsDialogPages.WaypointGroupSelection);
    },
  },
});
</script>

<style scoped>
.thumbnails .thumbnail{
  max-width: 70px;
  display: inline-flex;
  margin-right: 10px;
  position: relative;
}

.thumbnail .delete-button{
    position: absolute;
    top: 0;
    right: 0;
    padding: 0 !important;
    height: 20px;
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #DB2B35;
}
</style>
